import { observable, action, runInAction } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/yun_xuan/potentialCustomersApi'
import moment from 'moment'

class Store extends BaseStore {
  $listApi = Api.getList
  @observable activeTab = 'all'
  @observable score = 0
  @observable status = 1
  @observable countData = {}
  @action
  changeTab = key => {
    this.activeTab = key
    this.$getList(1)
  }
  @action
  initTab = key => {
    this.activeTab = key
  }
  $getParams = () => {
    const { activeTab } = this
    return {
      status: activeTab == 'all' ? '' : activeTab
    }
  }

  @action
  getCount = async () => {
    const { success, data } = await Api.getCount()
    const { count, wait_count, push_count, guest_count, expired_count } =
      data || {}
    runInAction(() => {
      if (success) {
        this.countData = Object.assign({}, this.countData, {
          count,
          wait_count,
          push_count,
          guest_count,
          expired_count
        })
      }
    })
  }

  @action
  getInfo = async () => {
    const { success, data } = await Api.getInfo()
    const { score, status } = data || {}
    runInAction(() => {
      if (success) {
        this.score = +score || 0
        this.status = status || 1
      }
    })
  }
  calcDay = (date, type) => {
    return Math.round(
      { 1: 7, 2: 30 }[type] - (moment() - moment(date)) / 1000 / 60 / 60 / 24
    )
  }
  jumpPage = () => {
    window.open('#/localMerchant/potentialCustomers/introduce')
  }
}

export default Store
